import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
import './dashboard.css';
import { MdManageAccounts } from 'react-icons/md';
import {
    AreaChart, Area, BarChart,
    Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

import Projectsdeshboard from './projects_root/projects-deshboard';
import Upcomingtask from './upcomingtask';
import Workloghistory from './work-log-history';
import '../components/team_ui.css';

export default function Dashboarddata() {
    const navigate = useNavigate();
    const [adminguid] = useState(Cookies.get("adminguid"));
    const [isLoading, setIsLoading] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [userdata, setUserdata] = useState([
        { name: "Users", value: 0 },
        { name: "Online", value: 0 },
        { name: "Work", value: 0 }
    ]);
    const [workdata, setworkdata] = useState({});
    const [projectsdata, setprojectsdata] = useState([
        { name: 'Project', value: 0 },
        { name: 'Task', value: 0 },
        { name: 'Item', value: 0 },
        { name: 'Item (Unique)', value: 0 }
    ]);

    // Helper to get total W/I from workdata (across all dates)
    const getWorkTotals = (grouped) => {
        let totalW = 0, totalI = 0;
        Object.values(grouped).forEach(val => {
            totalW += val.W || 0;
            totalI += val.I || 0;
        });
        return { totalW, totalI };
    };

    const fetchteamUsers = async () => {
        setIsLoading(true);
        try {
            const teamQuery = query(
                collection(db, "projects_users"),
                where("adminguid", "==", adminguid)
            );
            const teamSnapshot = await getDocs(teamQuery);

            if (teamSnapshot.empty) {
                setUsersData([]);
                setUserdata([
                    { name: "Users", value: 0 },
                    { name: "Online", value: 0 },
                    { name: "Work", value: 0 }
                ]);
                setworkdata({});
                return;
            }

            const teamDocs = teamSnapshot.docs.map(doc => doc.data());
            const totalUsers = teamDocs.length;
            const onlineUsers = teamDocs.filter(user => user.onlinestatus === true).length;

            // Work/Item aggregation
            const tQuery = query(
                collection(db, "projectstaskitemstatus"),
                where("adminguid", "==", adminguid),
                where("status", "==", true)
            );
            const tSnap = await getDocs(tQuery);
            const grouped = {};
            const dailyItemuids = {};
            tSnap.forEach(doc => {
                const data = doc.data();
                const dateObj = data.date_time?.toDate?.();
                if (!dateObj) return;
                const dateKey = dateObj.toISOString().split('T')[0];
                if (!grouped[dateKey]) {
                    grouped[dateKey] = { W: 0, I: 0 };
                    dailyItemuids[dateKey] = new Set();
                }
                // Sum status_complete
                if (typeof data.status_complete === 'number' && data.status_complete > 0) {
                    grouped[dateKey].W += data.status_complete;
                }
                // Count unique itemuid per date
                if (data.itemuid && !dailyItemuids[dateKey].has(data.itemuid)) {
                    dailyItemuids[dateKey].add(data.itemuid);
                    grouped[dateKey].I++;
                }
            });
        // Calculate totalW and totalI
const { totalW, totalI } = getWorkTotals(grouped);

// If you want to normalize by number of days or items
const dayCount = Object.keys(dailyItemuids).length;
const normalizedWork = dayCount > 0 ? totalW / dayCount : 0;

setUsersData(teamDocs);
setUserdata([
    { name: "Users", value: totalUsers },
    { name: "Online", value: onlineUsers },
    { name: "Work", value: normalizedWork/100 +"%" }
]);
        } catch (error) {
            console.error("Error fetching team users:", error);
        } finally {
            setIsLoading(false);
        }
    };

const fetch_projectstaskData = async () => {
    try {
        const pQuery = query(
            collection(db, "projects"),
            where("adminguid", "==", adminguid)
        );
        const tQuery = query(
            collection(db, "projectstask"),
            where("adminguid", "==", adminguid),
            where("status", "==", true)
        );
        const iQuery = query(
            collection(db, "projectstaskitem"),
            where("adminguid", "==", adminguid),
            where("status", "==", true)
        );
        const sQuery = query(
            collection(db, "projectstaskitemstatus"),
            where("adminguid", "==", adminguid),
            where("status", "==", true)
        );

        // Fetch all collections in parallel
        const [pSnap, tSnap, iSnap, sSnap] = await Promise.all([
            getDocs(pQuery),
            getDocs(tQuery),
            getDocs(iQuery),
            getDocs(sQuery)
        ]);

        // Calculate daily item work count
        const grouped = {};
        const dailyItemuids = {};
        sSnap.forEach(doc => {
            const data = doc.data();
            const dateObj = data.date_time?.toDate?.();
            if (!dateObj) return;
            const dateKey = dateObj.toISOString().split('T')[0];
            if (!grouped[dateKey]) {
                grouped[dateKey] = { W: 0, I: 0 };
                dailyItemuids[dateKey] = new Set();
            }
            if (typeof data.status_complete === 'number' && data.status_complete > 0) {
                grouped[dateKey].W += data.status_complete;
            }
            if (data.itemuid && !dailyItemuids[dateKey].has(data.itemuid)) {
                dailyItemuids[dateKey].add(data.itemuid);
                grouped[dateKey].I++;
            }
        });

        const dayCount = Object.keys(dailyItemuids).length;

        const result = [
            { name: 'Project', value: pSnap.size },
            { name: 'Task', value: tSnap.size },
            { name: 'Item', value: iSnap.size },
            { name: 'Work', value: dayCount }
        ];

        setprojectsdata(result);
    } catch (error) {
        console.error("Error fetching task data:", error);
    }
};

    useEffect(() => {
        fetchteamUsers();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        fetch_projectstaskData();
        // eslint-disable-next-line
    }, [adminguid, workdata]);

    return (
        <div className='dashboard-body'>
            {/* Dashboard */}
            <div className='post-container'>
                <div className='post_updates'>
                    <Projectsdeshboard />
                </div>
                <div className='post_div'>
                    <div className="dashboard-grid">
                        <div className="dashboard-items">
                            <div className='items-hd'>
                                <div className="item-title-text">Overview</div>
                                <div className="item-count-text">
                                    {projectsdata.reduce((acc, cur) => acc + cur.value, 0)}
                                </div>
                            </div>
                            <div style={{ width: '100%', height: 150 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <AreaChart
                                        data={projectsdata}
                                        margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
                                    >
                                        <defs>
                                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#275DF5" stopOpacity={0.16} />
                                                <stop offset="95%" stopColor="#275DF5" stopOpacity={0.05} />
                                            </linearGradient>
                                        </defs>
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                        <XAxis dataKey="name" axisLine={false} tickLine={false} />
                                        <YAxis axisLine={false} tickLine={false} />
                                        <Tooltip
                                            contentStyle={{
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                border: 'none',
                                            }}
                                        />
                                        <Area
                                            type="monotone"
                                            dataKey="value"
                                            stroke="#275DF5"
                                            strokeWidth={3}
                                            fillOpacity={1}
                                            fill="url(#colorUv)"
                                        />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                        <div className="dashboard-items">
                            <div className='items-hd'>
                                <div className="item-title-text">Team</div>
                                <MdManageAccounts onClick={() => navigate('/team')} title='Settings' className='settings-img' />
                            </div>
                            <br />
                            <div style={{ width: '100%', height: 150 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart
                                        data={userdata}
                                        barSize={40}
                                        margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                        <XAxis dataKey="name" axisLine={false} tickLine={false} />
                                        <YAxis axisLine={false} tickLine={false} />
                                        <Tooltip
                                            contentStyle={{
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                border: 'none',
                                            }}
                                        />
                                        <Bar
                                            dataKey="value"
                                            radius={[8, 8, 0, 0]}
                                            fill="url(#gradientFill)"
                                        />
                                        <defs>
                                            <linearGradient id="gradientFill" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#275DF5" stopOpacity={1} />
                                                <stop offset="95%" stopColor="#275DF5" stopOpacity={1} />
                                            </linearGradient>
                                        </defs>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                    <Upcomingtask />
                </div>
                <div className='post_updates'>
                    <Workloghistory />
                </div>
            </div>
        </div>
    );
}